"use strict";

var _regeneratorRuntime = require("/opt/buildhome/repo/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.API = void 0;

var auth_1 = require("./controllers/auth");

var category_1 = require("./controllers/category");

var club_1 = require("./controllers/club");

var event_1 = require("./controllers/event");

var hacker_1 = require("./controllers/hacker");

var sponsor_1 = require("./controllers/sponsor");

var RestManager_1 = require("./RestManager");

var API = /*#__PURE__*/function () {
  function API() {
    _classCallCheck(this, API);

    this.rest = new RestManager_1.RestManager();
    this.categories = new category_1.CategoryManager(this, this.rest);
    this.events = new event_1.EventManager(this.rest);
    this.sponsors = new sponsor_1.SponsorManager(this.rest);
    this.hackers = new hacker_1.HackerManager(this.rest);
    this.club = new club_1.ClubManager(this.rest);
  }

  _createClass(API, [{
    key: "login",
    value: function login(username, password) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return auth_1.AuthenticationManager.login({
                  username: username,
                  password: password
                });

              case 2:
                this.token = _context.sent;
                return _context.abrupt("return", this.token);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return API;
}();

exports.API = API;